import { Button, GridColumn } from "designSystem/index";
import React from "react";

export default () => {
	return (
		<GridColumn
			height={300}
			scroll
			spacing={10}
			textAlign="left"
		>
			<Button
				design="secondary"
				res="Button1"
			/>
			<Button
				design="primary"
				res="Button2"
			/>
			<Button
				design="secondary"
				res="Button3"
			/>
			<Button
				design="secondary"
				res="Button4"
			/>
			<Button
				design="primary"
				res="Button5"
			/>
			<Button
				design="secondary"
				res="Button6"
			/>
			<Button
				design="secondary"
				res="Button1"
			/>
			<Button
				design="primary"
				res="Button2"
			/>
			<Button
				design="secondary"
				res="Button3"
			/>
			<Button
				design="secondary"
				res="Button4"
			/>
			<Button
				design="primary"
				res="Button5"
			/>
			<Button
				design="secondary"
				res="Button6"
			/>
		</GridColumn>
	);
};